export default __webpack_public_path__ + "static/contact-3b9453f8c93a34ab8e5164659fb3caae.jpg";